import './styles/styles.css'
import * as React from 'react';
import Box from '@mui/material/Box';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Link} from 'react-router-dom'
// import { Button } from 'reactstrap';
import BCButom from '../Tools/BCButom';
import { BsFillTelephoneFill } from "react-icons/bs";
// import { CiMail } from "react-icons/ci";
import 'bootstrap/dist/css/bootstrap.min.css';

import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';


const Header = () => {
    
    const [isOpen, setIsOpen] = React.useState(false);
    return (
    <div id="container">
        <div id='menuDesktop'>
            <ul id="menu">
            <div id='title'>
            <div id='containerRight'>
                <span><b>کلینیک فوق تخصصی جراحی عروق مشهد</b></span>
            </div>
                <div id='containerLeft'> 
                    <a href='tel:۰۵۱۳۲۲۳۸۷۰۹' className='d-inline-block ps-0 pe-0 pb-0 pt-0 '><BCButom className='d-inline-block btnOne' style={{margin: "1px", padding: "5px 10px 5px 10px"}}><BsFillTelephoneFill/> ۰۵۱-۳۲۲۳۸۷۰۹</BCButom></a>
                    <a href='tel:۰۵۱۳۲۲۳۸۷۰۹' className='d-inline-block ps-0 pe-0 pb-0 pt-0 '><BCButom className='d-inline-block btnOne' style={{margin: "1px", padding: "5px 10px 5px 10px"}}><BsFillTelephoneFill/>۰۵۱-۳۲۲۳۸۷۰۸ </BCButom></a>
                    <a href='tel:۰۵۱۳۲۲۳۸۷۰۹' className='d-inline-block ps-0 pe-0 pb-0 pt-0 '><BCButom className='d-inline-block btnOne' style={{margin: "1px", padding: "5px 10px 5px 10px"}}><BsFillTelephoneFill/>info@modaghegh.com</BCButom></a>
                </div>
            </div>
                <li><Link to={`/`}>خانه</Link></li>
                <li><a>معرفی کلینیک</a>
                <ul>
                    <li><Link to={`/about`}>درباره دکتر مدقق</Link></li>
                    <li><Link to={`/empty`}>اعضای کلینیک</Link></li>
                    <li><Link to={`/contactUs`}>ساعت فعالیت کلینیک</Link></li>
                    <li><Link to={`/empty`}>فعالیت ها</Link></li>
                    <li><Link to={`/empty`}>تاریخچه</Link></li>
                    <li><Link to={`/empty`}>همکاران</Link></li>
                </ul>
                </li>
                <li><a href="#">وبلاگ</a>
                <ul>
                    <li><Link to={`/empty`}>اخبار</Link></li>
                    <li><Link to={`/posts`}>مقالات</Link></li>
                </ul>
                </li>
                <li><a>لینک های مفید</a>
                <ul>
                    <li><a target={`blonk`} href="https://www.kojaro.com/attraction/list/mashhad-28516-ci/sort/13/">مکان های گردشگری مشهد</a></li>
                    <li><a target={`blonk`} href="https://safarmarket.com/blog/attractions/iran/mashhad/imam-reza-holy-shrine">حرم امام رضا (ع)</a></li>
                    <li><a target={`blonk`} href="https://dotic.ir/cat/129">وزارت بهداشت</a></li>
                    <li><a target={`blonk`} href="https://irimc.org/">سازمان نظام پزشکی</a></li>
                    <li><a target={`blonk`} href="http://isvs.ir/">انجمن جراحان عروق</a></li>
                    <li><a target={`blonk`} href="https://iums.ac.ir/">دانشگاه علوم پزشکی</a></li>
                    <li><a target={`blonk`} href="https://www.mums.ac.ir/">دانشگاه علوم پزشکی مشهد </a></li>
                    <li><a target={`blonk`} href="https://tums.ac.ir/">دانشگاه علوم پزشکی تهران </a></li>
                </ul>
                </li>
                <li><a>کلینیک های تخصصی</a>
                <ul>
                    <li><Link to={`/empty`}>واریس</Link></li>
                    <li><Link to={`/empty`}>رخم پای دیابتی</Link></li>
                    <li><Link to={`/empty`}>پایش سلامت عروقی</Link></li>
                    <li><Link to={`/empty`}>لنف ادم (لنفوتراپی)</Link></li>
                    <li><Link to={`/empty`}>چکاپ بیمار دیابتی</Link></li>

                </ul>
                </li>
                <li><a >ارتباط با پزشک</a>
                    <ul>
                    <li><Link to={`/contactUs`}>راه های ارتباطی</Link></li>     
                    <li><a target="_blank" href="https://app.minns.cloud/reservations/home/1">مشاوره و ارتباط با پزشک</a></li>
                    <li><Link to={`/colleagueChat`}>تالار گفتگوی همکاران</Link></li>
                    <li><Link to={`/studentChat`}>تالار گفتگوی دانشجویان</Link></li>
                    </ul>
                </li>
                <li><a href="https://app.minns.cloud/reservations/reserve/1">نوبت دهی</a></li>
                <li><a href="https://app.minns.cloud/admin/patient">سامانه ثبت بیماری</a></li>
                <li><Link to={`/galery`}>گالری</Link></li>
                
                
            </ul>
        </div>

        
        <div id='menuMobile' dir='rtl'>
        {['sm'].map((expand) => (
        <Navbar key={expand} bg="dark" style={{color: "#fff", margin: "0px", top: "0px"}} expand={expand} className="" dir='rtl'>
          <Container style={{color: "#fff"}} fluid bg='dark'>
            <Navbar.Brand style={{fontSize: "13px", color: "#fff"}} href="#">کلینیک فوق تخصصی جراحی عروق مشهد</Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas id={`offcanvasNavbar-expand-${expand}`} aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`} placement="end" >
              <div style={{ borderBottom: "#ccc solid 1px"}}>
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`} style={{fontSize: "15px", color: "#2f2f2f"}}>
                  کلینیک فوق تخصصی جراحی عروق مشهد
                </Offcanvas.Title>
              </Offcanvas.Header>
              </div>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                <Nav.Link><Link to={`/`}>خانه</Link></Nav.Link>
                <NavDropdown title="معرفی کلینیک" id={`offcanvasNavbarDropdown-expand-${expand}`}>
                    <NavDropdown.Item><Link to={`/news`}>درباره دکتر مدقق</Link></NavDropdown.Item>
                    <NavDropdown.Item><Link to={`/empty`}> اعضای کلینیک </Link></NavDropdown.Item>
                    <NavDropdown.Item><Link to={`/contactUs`}> ساعت کاری فعالیت کلینیک </Link></NavDropdown.Item>
                    <NavDropdown.Item><Link to={`/empty`}> فعالیت ها </Link></NavDropdown.Item>
                    <NavDropdown.Item><Link to={`/empty`}> تاریخچه </Link></NavDropdown.Item>
                    <NavDropdown.Item><Link to={`/empty`}> هعمکاران </Link></NavDropdown.Item>
                <NavDropdown.Divider />
                </NavDropdown>
                <NavDropdown title="وبلاگ" id={`offcanvasNavbarDropdown-expand-${expand}`}>
                    <NavDropdown.Item><Link to={`/empty`}>اخبار</Link></NavDropdown.Item>
                    <NavDropdown.Item><Link to={`/posts`}>مقالات</Link></NavDropdown.Item>
                    <NavDropdown.Divider />
                </NavDropdown> 
                

                <NavDropdown title="لینک های مفید" id={`offcanvasNavbarDropdown-expand-${expand}`}>
                    <NavDropdown.Item><Link style={{zIndex: 555}} href="https://www.kojaro.com/attraction/list/mashhad-28516-ci/sort/13/">مکان های گردشگری مشهد</Link></NavDropdown.Item>
                    <NavDropdown.Divider />
                  </NavDropdown>

                  <NavDropdown title="ارتباط با پزشک" id={`offcanvasNavbarDropdown-expand-${expand}`}>
                    <NavDropdown.Item><Link to={`/contactUs`}>راه های ارتباطی</Link></NavDropdown.Item>
                    <NavDropdown.Item><Link to={``}>مشاوره و ارتباط با پزشک</Link></NavDropdown.Item>
                    
                    <NavDropdown.Item><Link to={`/colleagueChat`}>تالار گفتگوی همکاران</Link></NavDropdown.Item>
                    <NavDropdown.Item><Link to={`/studentChat`}>تالار گفتگوی دانشجویان</Link></NavDropdown.Item>
                    
                    <NavDropdown.Divider />
                </NavDropdown> 
                  
                <Nav.Link><Link to={`/galery`}>گالری</Link></Nav.Link>
                  
                  
                  
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
        </div>
    </div>
    )
}
export default Header;